import React, { createContext, useContext, useState, useEffect } from 'react';
import { apiGetMe, apiLogin, apiLogout } from '../lib/api';

const AuthContext = createContext(null);

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = checking, false = unauthenticated, object = authenticated
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem('access_token');
      if (!token) {
        setUser(false);
        setLoading(false);
        return;
      }
      try {
        const { data } = await apiGetMe();
        setUser(data);
      } catch (e) {
        localStorage.removeItem('access_token');
        setUser(false);
      } finally {
        setLoading(false);
      }
    };
    checkAuth();
  }, []);

  const login = async (email, password) => {
    const { data } = await apiLogin(email, password);
    if (data.access_token) {
      localStorage.setItem('access_token', data.access_token);
    }
    setUser({
      id: data.id,
      email: data.email,
      name: data.name,
      role: data.role,
    });
    return data;
  };

  const logout = async () => {
    try {
      await apiLogout();
    } catch (e) {
      // ignore
    }
    localStorage.removeItem('access_token');
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
